<template>
  <div class="title-bar">
    <div class="title-bar__icon-wrapper">
      <IneSmallLogo />
      <ExerciseIcon class="title-bar__icon" />
    </div>
    <div class="title-bar__title-wrapper">
      <h4 class="title-bar__title">{{ exercise.name }}</h4>
      <CheckIcon
        class="status-icon"
        v-tooltip="{
          content: exercise.user_status,
          placement: 'right-center',
        }"
        :fill="hasCompleted"
      />
    </div>
    <div class="exercises-navigator">
      <slot name="nav"></slot>
    </div>
    <div
      class="title-bar__report-issue"
      @click.stop="$emit('start-issue')"
      v-if="canSendIssues"
    >
      <IssueIcon class="title-bar__report-issue__icon" />
      Report an issue
    </div>
    <div
      class="title-bar__close-modal"
      :class="!canSendIssues && 'title-bar__close-modal--right'"
    >
      <button @click="$emit('close-modal')" class="title-bar__close-modal-btn">
        <CloseIcon fill="#FFFFFF" class="title-bar__close-icon" />
      </button>
    </div>
  </div>
</template>

<script>
import ExerciseIcon from '@/assets/icons/course/exercise/terminal-icon.svg'
import CloseIcon from '@/assets/icons/navigation/close_icon.svg'
import IneSmallLogo from '@/assets/icons/course/exercise/ine-small-logo.svg'
import CheckIcon from '@/assets/icons/course/exercise/check-circle.svg'
import IssueIcon from '@/assets/icons/course/bug.svg'
import CONSTANTS from '@/constants'

export default {
  name: 'TitleBar',
  components: {
    ExerciseIcon: { ...ExerciseIcon, name: 'ExerciseIcon' },
    CloseIcon: { ...CloseIcon, name: 'CloseIcon' },
    IneSmallLogo: { ...IneSmallLogo, name: 'IneSmallLogo' },
    CheckIcon: { ...CheckIcon, name: 'CheckIcon' },
    IssueIcon: { ...IssueIcon, name: 'IssueIcon' },
  },
  props: {
    exercise: {
      type: Object,
      required: true,
    },
    canSendIssues: {
      type: Boolean,
      required: false,
      default: () => {
        return true
      },
    },
  },
  computed: {
    hasCompleted() {
      if (
        this.exercise.user_status === CONSTANTS.CONTENT_USER_STATUS.FINISHED
      ) {
        return '#00DEA0'
      }
      return '#727276'
    },
  },
}
</script>

<style lang="scss" scoped>
.title-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 0 auto;
  padding: 30px 30px 50px 30px;
  max-width: 2400px;
  z-index: 204;
  background: var(--dark-gray);
  border-top: 5px solid var(--orange);
  border-bottom: 1px solid #424040;
  max-height: 100px;
  &__icon-wrapper {
    display: flex;
    align-items: center;
    width: 120px;
    justify-content: space-between;
  }
  &__icon {
    width: 25px;
    margin-top: 5px;
  }
  &__title-wrapper {
    width: 40%;
    display: flex;
    align-items: center;
    .status-icon {
      margin-top: 3px;
    }
    @include desktop {
      width: 41%;
    }
  }
  &__title {
    margin: 0;
    padding: 0;
    font-size: 1rem;
    line-height: 1rem;
    display: none;
    @include mobile {
      display: block;
    }
    @include desktop {
      font-size: 18px;
      line-height: 2.5rem;
      margin-top: 3px;
      margin-right: 20px;
    }
  }
  &__close-modal {
    display: flex;
    align-items: center;
    margin-left: 20px;
    &--right {
      margin-left: auto;
    }
  }
  &__close-text {
    display: none;
    color: var(--lighter-gray);
    font-size: 16px;
    margin: 0;
    @include desktop {
      display: block;
    }
  }
  &__close-modal-btn {
    background: none;
    border: none;
    cursor: pointer;
    &:hover {
      opacity: 0.5;
    }
  }
  &__close-icon {
    margin: 8px 0 0 0;
    color: var(--black);
  }
  &__report-issue {
    display: flex;
    align-items: center;
    margin-left: auto;
    font-size: 14px;
    cursor: pointer;
    &__icon {
      margin-right: 5px;
      fill: white;
    }
  }
}
</style>
